import styled from '@emotion/styled';

import {getTransparentColor} from 'Utils';

export const StyledPickerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  // margin-top: ${(props) => (props.offset ? '-12px' : '0')};
  * {
    box-sizing: content-box;
  }

  .react-datepicker {
    font-family: ${({theme}) => theme.typography.fontFamily};
    letter-spacing: .03em;
    border: 0px solid ${({theme}) => theme.palette.common.swatch['30']};
    border-radius: 8px;
    font-size: ${(props) => (props.size === 'small' ? '0.875rem' : '1rem')};;
    display: block;
  }

  .react-datepicker__day--outside-month {
    &:not(.react-datepicker__day--selected) {
      color: ${({theme}) => theme.palette.common.swatch['60']} !important;
    }
    opacity: 40%;
    &.react-datepicker__day--disabled {
      color: ${({theme}) => theme.palette.common.swatch['40']} !important;
    }
  }

  .react-datepicker__navigation {
    text-indent: unset;
    height: 24px;
    width: 24px;
  }

  .react-datepicker__navigation-icon {
    font-size: 14px;
  }

  .react-datepicker__navigation--previous {
    left: -5px;
    top: 12px;
    &::before {
      content: initial;
    }
  }

  .react-datepicker__navigation-icon::before {
    content: initial;
  }

  .react-datepicker__navigation--next {
    left: 24px;
    top: 12px;
    &::before {
      content: initial;
    }
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    padding: 5px 0px;
    font-size: 1rem;
    line-height: 24px;
    color: ${({theme}) => theme.palette.text.primary} !important;
  }
  
  
  .react-datepicker__header {
    background-color: transparent;
    border-bottom: unset;
    text-align: unset;
    ${(props) => (props.size === 'small' ? 'padding-bottom: 0;' : '')};
  }

  .react-datepicker__day-name {
    color: ${({theme}) => theme.palette.common.swatch['60']};
    width: 1.75rem;
    font-weight: 500;
  }

  .react-datepicker__month {
    margin-top: 0px;
  }

  .react-datepicker__day-names {
    text-align: center;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin: 9px 8px;
    padding: 2px;
    border-radius: 2rem;
  }

  .react-datepicker__day {
    transition: all 300ms;
    height: 2rem;
    width: 2rem;
    line-height: calc(2rem - 4px); // account for padding*2
    box-sizing: border-box;
    border-radius: 2.25rem;
    &:hover {
      border-radius: 2.25rem;
    }
  }

  .day-loading {
    -webkit-animation-duration: 1.25s;
    -webkit-animation-fill-mode: forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: placeHolderShimmer;
    -webkit-animation-timing-function: linear;
    color: ${({theme}) => theme.palette.common.swatch['60']};
    background: #e7eaed;
    background-image: linear-gradient(
      90deg, 
      rgba(255, 255, 255, 0) 0, 
      rgba(255, 255, 255, 0.2) 20%, 
      rgba(255, 255, 255, 0.5) 60%, 
      rgba(255, 255, 255, 0)
    );
    background-repeat: no-repeat;
  }

  @-webkit-keyframes placeHolderShimmer {
    0% {
      background-position: -40px 0
    }
    100% {
      background-position: 40px 0
    }
    
  }
  
  .day-unavailable {
    background-color: transparent;
    border: 1px solid transparent;
    color: ${({theme}) => theme.palette.common.swatch['60']};
    font-weight: 500;
    &:hover {
      background-color: transparent;
      border: 1px solid transparent;
      box-shadow: initial;
      color: ${({theme}) => theme.palette.common.swatch['60']};
      font-weight: 500;
    }
  }
  
  .day-available {
    font-weight: bold;
    border-radius: 2.25rem;
    color: ${({theme}) => theme.palette.button.default};
    background-color: ${({theme}) => getTransparentColor(theme.palette.button.default, 0.05)};
    &:hover {
      background-color: ${({theme}) => getTransparentColor(theme.palette.button.default, 0.15)};
    }
  }

  .react-datepicker__day--disabled, 
  .react-datepicker__month-text--disabled, 
  .react-datepicker__quarter-text--disabled, 
  .react-datepicker__year-text--disabled {
    opacity: 0.5;
    background-color: transparent;
    border: 1px solid transparent;
    color: ${({theme}) => theme.palette.common.swatch['60']};
    font-weight: normal;
    &:hover {
      background-color: transparent;
      border: 1px solid transparent;
      box-shadow: initial;
      color: ${({theme}) => theme.palette.common.swatch['60']};
      font-weight: normal;
    }
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: 2.25rem;
    // background-color: ${({theme}) => theme.palette.primary.swatch['10']};
    &:hover {
      box-shadow: 0px 4px 8px rgba(19, 22, 25, 0.1), 0px 2px 4px rgba(19, 22, 25, 0.1);
      background-color: ${({theme}) => theme.palette.primary.swatch['10']};
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    font-weight: bold;
    border-color: ${({theme}) => theme.palette.button.default};
    background-color: ${({theme}) => theme.palette.button.default};
    color: #fff;
    &:hover {
      border-color: ${({theme}) => theme.palette.button.default};
      background-color: ${({theme}) => theme.palette.button.default};
      color: #fff;
      font-weight: bold;
    }
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__quarter-text--today,
  .react-datepicker__year-text--today {
    position: relative;
  }
  .react-datepicker__day--today::after {
    content: '';
    background-color: ${({theme}) => theme.palette.secondary.swatch['50']};
    border-radius: 12px;
    display: block;
    height: 6px;
    width: 6px;
    top: calc(100% + 3px);
    left: calc(50% - 3px);
    position: absolute;
  }

  .react-datepicker__today-button {
    position: absolute;
    top: .125rem;
    left: 10.4375rem;
    display: inline-block;
    padding: 5px 9px 5px 10px;
    border-radius: .5rem;
    font-weight: 500;
    font-size: .875rem;
    line-height: 1.25rem;
    box-shadow: unset;
    text-transform: unset;
    color: ${({theme}) => theme.palette.common.swatch['90']};
    background: ${({theme}) => theme.palette.common.white};
    border: 1px solid ${({theme}) => theme.palette.common.swatch['30']};
  }

  .react-datepicker__today-button:hover {
    background: ${({theme}) => theme.palette.common.swatch['10']};
    box-shadow: unset,
  }

  .react-datepicker__today-button:active {
    background: ${({theme}) => theme.palette.common.swatch['20']};
    box-shadow: unset,
  }
}
`;
